// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Nrfc","rootCenter":"LoadMoreObserver_rootCenter__3sXny","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3_HWe"};